import { render } from "./TextBox_Action.vue?vue&type=template&id=65b8bc00"
import script from "./TextBox_Action.vue?vue&type=script&lang=js"
export * from "./TextBox_Action.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__